import userSettingsIcon from '../assets/userSetings.png';
import vagasBlue from '../assets/vagasBlue.png';
import concessionWhite from '../assets/concessionWhite.png';
import statistics from '../assets/statistics.png';
import termoBlue from '../assets/termoBlue.png';
import clipboardBlue from '../assets/clipboardBlue.png';
import contrapartidaIconBlue from '../assets/contrapartidaIconBlue.png';
import minhaConta from '../assets/minhaConta.png';


// CARGOID 1 -> 'Admin - Gerenciador geral dos estágios - ESP
// CARGOID 2 -> 'Coordenador da instituição de ensino 
// CARGOID 3 -> 'Coordenador de estágio ou curso
// CARGOID 4 -> 'Profissional do Estabelecimento de saúde (NEPS/ GEPS)

// ADMIN - cargoid 1
const ESP_SIDEBAR = [
  {
    key: 'estabelecimentos-saude',
    label: 'Estabelecimentos de Saúde',
    icon: 'domain',
    requiresAdmin: true,
    subItems: [
      {
        key: 'estabelecimentos-saude',
        label: 'Estabelecimentos de Saúde',
        path: '/EstabelecimentosSaude'
      },
      {
        key: 'cadastrar-estabelecimento',
        label: 'Cadastrar Estabelecimento',
        path: '/CadastrarEstabelecimentoSaude'
      }
    ]
    
  },
  {
    key: 'insituicoes-ensino',
    label: 'Instituições de Ensino',
    icon: 'school',
    requiresAdmin: true,
    subItems: [
      {
        key: 'campis',
        label: 'Campis',
        icon: 'domain',
        path: '/Campis'
      },
      {
        key: 'cursos',
        label: 'Cursos',
        icon: 'school',
        path: '/Cursos'
      },
      {
        key: 'areas-curso',
        label: 'Áreas de Curso',
        icon: 'category',
        path: '/AreasCurso'
      }
    ]
  },
  {
    key: 'usuarios',
    label: 'Usuários',
    icon: 'group',
    requiresAdmin: true,
    subItems: [
      {
        key: 'usuarios-pendentes',
        label: 'Usuários Pendentes',
        path: '/UsersPendentes'
      },
      {
        key: 'usuarios-ativos',
        label: 'Usuários Ativos',
        path: '/UsersAtivos'
      }
    ]
  },
  {
    key: 'vagas',
    label: 'Vagas',
    icon: vagasBlue,
    iconType: 'image',
    subItems: [
      {
        key: 'vagas-disponibilizadas',
        label: 'Vagas Disponibilizadas',
        path: '/VagasDisponibilizadas'
      },
      {
        key: 'cadastrar-vagas',
        label: 'Cadastrar Vagas',
        path: '/CadastrarVagasEstagio2'
      },
    ]
  },
  // {
  //   key: 'especialidades',
  //   label: 'Especialidades',
  //   icon: especialitiesBlue,
  //   iconType: 'image',
  //   subItems: [
  //     {
  //       key: 'especialidades-med',
  //       label: 'Especialidades',
  //       path: '/EspecialidadesMed'
  //     },
  //     {
  //       key: 'cadastrar-especialidades',
  //       label: 'Cadastrar Especialidades',
  //       path: '/CadastrarEspecialidadess'
  //     }
  //   ]
  // },
  // {
  //   key: 'gerenciarCadastros',
  //   label: 'Gerenciar Cadastros',
  //   icon: userSettingsIcon,
  //   iconType: 'image',
  //   path: '/GerenciarCadastro',
  //   subItems: [
  //     {
  //       key: 'estabelecimento-saude',
  //       label: 'Estabelecimento de Saúde',
  //       path: '/EstabelecimentoSaude'
  //     },
  //   ]
  // },
  {
    key: 'minha-conta',
    label: 'Minha Conta',
    icon: userSettingsIcon,
    iconType: 'image',
    subItems: [
      {
        key: 'minha-conta',
        label: 'Perfil',
        path: '/Profile'
      },
      {
        key: 'seguranca-conta',
        label: 'Segurança',
        path: '/EditarConta'
      }
    ]
  },
];

// IE e CE - Cargoid 2 e 3
const INSTITUICAO_ENSINO_SIDEBAR = [
  {
    key: 'campis',
    label: 'Campis',
    icon: 'domain',
    path: '/Campis'
  },
  {
    key: 'cursos',
    label: 'Cursos',
    icon: 'school',
    path: '/Cursos'
  },
  {
    key: 'vagas',
    label: 'Vagas',
    icon: vagasBlue,
    iconType: 'image',
    path: '/VagasDisponibilizadas',
    subItems: [
      {
        key: 'estagio-obrigatorio',
        label: 'Estágio Obrigatório',
        path: '/EstagioObrigatorio'
      },
      {
        key: 'residencia',
        label: 'Residência',
        path: '/Residencia'
      },
      {
        key: 'aula-pratica',
        label: 'Aula Prática',
        path: '/AulaPratica'
      },
      {
        key: 'vagas-solicitadas',
        label: 'Vagas Solicitadas',
        path: '/VagasSolicitadas',
      },
    ]
  },
  {
    key: 'concessoes',
    label: 'Concessões / Validações',
    icon: concessionWhite,
    iconType: 'image',
    subItems: [
      {
        key: 'confirmação',
        label: 'Confirmação de Concessões',
        path: '/ConfirmarConcessao',
        // disabled: true,
      },
      {
        key: 'cadastar-alunos',
        label: 'Cadastrar Alunos',
        path: '/CadastrarAlunos',
      },
    ]
  },
  {
    key: 'termo-compromisso',
    label: 'Termo de Compromisso',
    icon: termoBlue,
    iconType: 'image',
    subItems: [
      {
        key: 'termo-compromisso-baixar-enviar',
        label: 'Baixar / Enviar',
        path: '/TermoCompromisso',
      },
      {
        key: 'termo-compromisso-pendentes',
        label: 'Pendentes',
        path: '/TermoCompromissoPendentes',
      },
    ],
  },
  {
    key: 'minha-conta',
    label: 'Minha Conta',
    icon: userSettingsIcon,
    iconType: 'image',
    subItems: [
      {
        key: 'minha-conta',
        label: 'Perfil',
        path: '/Profile'
      },
      {
        key: 'seguranca-conta',
        label: 'Segurança',
        path: '/EditarConta'
      }
    ]
  },
];

// ES - Cargoid 4
export const ESTABELECIMENTO_SAUDE_SIDEBAR = [
  {
    key: 'vagas',
    label: 'Vagas',
    icon: vagasBlue,
    iconType: 'image',
    subItems: [
      {
        key: 'vagas-disponibilizadas',
        label: 'Vagas Disponibilizadas',
        path: '/VagasDisponibilizadas'
      },
      {
        key: 'cadastrar-vagas',
        label: 'Cadastrar Vagas',
        path: '/CadastrarVagasEstagio2'
      },
    ]
  },
  // {
  //   key: 'especialidades',
  //   label: 'Especialidades',
  //   icon: especialitiesBlue,
  //   iconType: 'image',
  //   subItems: [
  //     {
  //       key: 'especialidades-med',
  //       label: 'Especialidades',
  //       path: '/EspecialidadesMed' //LISTA DE ESPECIALIDADES MEDICAS
  //     },
  //     {
  //       key: 'cadastrar-especialidades',
  //       label: 'Cadastrar Especialidades',
  //       path: '/CadastrarEspecialidades' //NOVA PAGINA - CADASTRO DE ESPECIALIDADES MEDICAS
  //     }
  //   ]
  // },
  {
    key: 'concessoes',
    label: 'Concessões / Validações',
    icon: concessionWhite,
    iconType: 'image',
    path: '/Concessoes',
    subItems: [
      {
        key: 'para-analise',
        label: 'Para Análise',
        path: '/ParaAnalise'
      },
      {
        key: 'nao-concedidas',
        label: 'Não Concedidas',
        path: '/NaoConcedidas'
      },
      {
        key: 'concedidas',
        label: 'Concedidas',
        path: '/Concedidas'
      },
      {
        key: 'confirmadas',
        label: 'Confirmadas',
        path: '/Confirmadas'
      },
    ]
  },
  {
    key: 'termo-compromisso',
    label: 'Termo de Compromisso',
    icon: termoBlue,
    iconType: 'image',
    subItems: [
      {
        key: 'termo-compromisso-assinados',
        label: 'Assinados',
        path: '/TermoCompromisso',
      },
      {
        key: 'termo-compromisso-pendentes',
        label: 'Pendentes',
        path: '/TermoCompromissoPendentes',
      },
    ],
  },
  {
    key: 'relatorioConcessao',
    label: 'Relatório de Concessão',
    icon: statistics,
    iconType: 'image',
    subItems: [
      {
        key: 'relatorio-concessao-campos-solicitados',
        label: 'Campos Solicitados',
        path: '/RelatorioConcessao/campos-solicitados'
      },
      {
        key: 'relatorio-concessao-campos-concedidos',
        label: 'Campos Concedidos',
        path: '/RelatorioConcessao/campos-concedidos',
        disabled: true,
      },
      {
        key: 'relatorio-concessao-campos-ocupados',
        label: 'Campos Ocupados',
        path: '/RelatorioConcessao/campos-ocupados',
        disabled: true,
      },
      {
        key: 'relatorio-concessao-contrapartida-gerada',
        label: 'Contrapartida Gerada',
        path: '/ContrapartidaGerada',
        disabled: true,
      }
    ]
  },
  {
    key: 'relatorios',
    label: 'Relatório de Atividade',
    icon: clipboardBlue,
    iconType: 'image',
    disabled: true,
    subItems: [
      {
        key: 'campos-solicitados',
        label: 'Campos Solicitados',
        path: '/CamposSolicitados'
      },
      {
        key: 'campos-concedidos',
        label: 'Campos Concedidos',
        path: '/CamposConcedidos'
      },
      {
        key: 'campos-ocupados',
        label: 'Campos Ocupados',
        path: '/CamposOcupados'
      },
      {
        key: 'contrapartida-gerada',
        label: 'Contrapartida Gerada',
        path: '/ContrapartidaGerada'
      },
      {
        key: 'contrapartida-utilizada',
        label: 'Contrapartida Utilizada',
        path: '/ContrapartidaUtilizada'
      }
    ]
  },
  {
    key: 'contrapartida',
    label: 'Contrapartida',
    icon: contrapartidaIconBlue,
    iconType: 'image',
    path: '/Contrapartida',
    disabled: true,
  },
  {
    key: 'minha-conta',
    label: 'Minha Conta',
    icon: minhaConta,
    iconType: 'image',
    subItems: [
      {
        key: 'minha-conta',
        label: 'Perfil',
        path: '/Profile'
      },
      {
        key: 'seguranca-conta',
        label: 'Segurança',
        path: '/EditarConta'
      },
      {
        key: 'estabelecimento-saude',
        label: 'Estabelecimento de Saúde',
        path: '/EstabelecimentosSaude'
      }
    ]
  },
];

// Função para filtrar os itens do sidebar baseado no cargoId do usuário
export const getCargoIdSidebar = (cargoId) => {
  if (cargoId === 1) {
    return ESP_SIDEBAR;
  }
  if (cargoId === 2) {
    return INSTITUICAO_ENSINO_SIDEBAR.map(item => {
      if (item.key === 'campis') {
        return {
          ...item,
          subItems: [
            {
              key: 'cadastrar-campis',
              label: 'Cadastrar Campis',
              path: '/CadastroCampis'
            }
          ]
        };
      }

      if (item.key === 'cursos') {
        return {
          ...item,
          subItems: [
            {
              key: 'cadastrar-cursos',
              label: 'Cadastrar Cursos',
              path: '/CadastroCurso'
            }
          ]
        };
      }

      return item;
    });
  }
  if (cargoId === 3) {
    return INSTITUICAO_ENSINO_SIDEBAR;
  }
  else if (cargoId === 4) {
    return ESTABELECIMENTO_SAUDE_SIDEBAR;
  }
};
